import React from "react";
import { Link } from "react-router-dom";
import amaxLogo from "../images/amaxLogoWhite.png";
import signUpBack from "../images/signUpBack.svg";
import astLogo from "../images/astBlackLogo.png"; // Ensure the correct path for your logo

export const AthleteStart = () => {
  return (
    <div className="p-[20px] bg-custom-image relative min-h-screen">
      {/* <div className="w-full max-w-2xl mx-auto h-full relative flex flex-col items-center gap-64 overflow-y-auto">
        <div className="size-[96px] lg:size-[166px] ml-auto">
          <Link to="/">
            <img src={amaxLogo} alt="logo" className="object-contain" />
          </Link>
        </div>
        <div className="w-full flex flex-col gap-20">
          <div className="w-full max-w-2xl space-y-5 pl-5 border-l-4 border-yellow-600 text-black text-lg xs:text-xl font-medium leading-tight">
            <div>
              <p>Athletes don’t need to work harder.</p>
              <p>
                They need a <strong className="font-bold">true system</strong>.
              </p>
            </div>
            <div>
              <p>We’re not adding work.</p>
              <p>We’re adding purpose.</p>
            </div>
            <div>
              <p>
                This is the <span className="uppercase">NEW STANDARD</span>.
              </p>
            </div>
          </div>
          <div className="w-full flex flex-col items-center gap-5">
            <Link to="/athlete/login" className="w-full">
              <button className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300">
                SIGN IN
              </button>
            </Link>
            <Link to="/athlete/register/step1" className="w-full">
              <button className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300">
                JOIN US
              </button>
            </Link>
          </div>
        </div>

        <div className="absolute top-24 left-1/2 -translate-x-1/2 w-[95%] xs:max-w-96 min-w-[280px] opacity-[3%]">
          <img src={signUpBack} alt="signUpBack" className="h-full w-full" />
        </div>
      </div> */}
      <div className="relative w-full max-w-2xl mx-auto h-full z-10 flex flex-col items-center justify-center pt-32 pb-10">
        <div className="flex flex-col gap-8 mb-28">
          <div className="size-60">
            <Link to="/">
              <img src={astLogo} alt="logo" className="object-contain" />
            </Link>
          </div>

          <div className="text-center">
            <p className="text-black text-base font-medium !leading-snug">
              Where Speed Development <br /> Becomes a System
            </p>
          </div>
        </div>
        <div className="w-full flex flex-col items-center gap-5">
          <Link to="/athlete/login" className="w-full">
            <button className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300">
              SIGN IN
            </button>
          </Link>
          <Link to="/athlete/register/step1" className="w-full">
            <button className="text-center w-full p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300">
              JOIN US
            </button>
          </Link>
        </div>
      </div>
      <div class="absolute inset-0 bg-white/80"></div>
    </div>
  );
};
